export function getScrollDistance(event) {
  const { deltaX, deltaY } = event;

  let scrollAmount = Math.abs(deltaX) > Math.abs(deltaY) ? -deltaX : -deltaY;

  // Normalize scroll amount--browsers are inconsistent here
  let direction = scrollAmount >= 0 ? 1 : -1;
  return (direction * 50) / 100000;
}
